import { Injectable, EventEmitter, Inject, forwardRef } from "@angular/core";
import { KreTableFieldConfig, KreFormFieldConfig, clone } from "@kre-form/core";
import { KreTableBusiness } from "./util";
import { KreToFormFieldService } from "./formFieldService";
import { min } from "rxjs/operators";

@Injectable()
export class KreAntCommonService {
  constructor(
    @Inject(KreToFormFieldService)
    private toFormField: KreToFormFieldService
  ) {}

  private findFieldConfig: any = {};
  //根据Guid获取Field
  getFormFieldByGuid(formFieldConfig: KreFormFieldConfig[], guid: string) {
    if (formFieldConfig.length) {
      formFieldConfig.forEach((item, index, object) => {
        if (item.guid === guid) {
          this.findFieldConfig = item;
        }
        if (item.type === "repeat") {
          if (
            item.fieldArray &&
            item.fieldArray &&
            item.fieldArray.fieldGroup &&
            item.fieldArray.fieldGroup.length > 0
          ) {
            this.getFormFieldByGuid(item.fieldArray.fieldGroup, guid);
          }
        }
      });
    }
    return this.findFieldConfig;
  }
}
